import * as Apollo from '@apollo/client'
import { useParams } from 'react-router'
import { ICurrentUserQuery, useCurrentUserQuery } from 'types'

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }

export const useImpersonatedCurrentUser = () => {
  const response = useCurrentUserQuery()
  const { id } = useParams<{ id: string }>()

  if (response.data && response.data.currentUser?.id === id) {
    return response
  }

  return { ...response, data: undefined } as Apollo.QueryResult<
    ICurrentUserQuery,
    Exact<{
      [key: string]: never
    }>
  >
}
